import { MyKidneyFunctionContent } from "./myKidneyFunction";

export const MyKidneyFunction = MyKidneyFunctionContent;
